import { watch } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import PersonalCoding from '../components/PersonalCoding.vue'
import LegalImpressum from '../components/legal/Impressum.vue'
import LegalDatenschutz from '../components/legal/Datenschutz.vue'
import LegalAGB from '../components/legal/AGB.vue'
import LegalAIAct from '../components/legal/AIAct.vue'
import AstroWuerfel from '../components/astrology/AstroWuerfel.vue'
import AIActImageConverter from '../components/tools/AIActImageConverter.vue'
import i18n from '../i18n'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: PersonalCoding
  },
  {
    path: '/learn',
    name: 'AstroWuerfel',
    component: AstroWuerfel,
    meta: {
      routeKey: 'learn',
      ogImage: 'https://i.ibb.co/p6L4bHsL/logo-Personal-Coding.png',
      robots: 'index,follow'
    },
    alias: ['/astrolernen', '/astrowürfel', '/astrowuerfel']
  },
  {
    path: '/newsletter',
    name: 'Newsletter',
    component: PersonalCoding
  },
  {
    path: '/impressum',
    name: 'LegalImpressum',
    component: LegalImpressum
  },
  {
    path: '/datenschutz',
    name: 'LegalDatenschutz',
    component: LegalDatenschutz
  },
  {
    path: '/agb',
    name: 'LegalAGB',
    component: LegalAGB
  },
  {
    path: '/ki-transparenz',
    name: 'LegalAIAct',
    component: LegalAIAct,
    alias: ['/ai-transparency']
  },
  {
    path: '/ai-act-image-converter',
    name: 'AIActImageConverter',
    component: AIActImageConverter,
    meta: {
      routeKey: 'aiActImage',
      robots: 'index,follow'
    },
    alias: ['/ai-act', '/ki-bilder', '/ai-bilder', '/ai-act-bilder']
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.name === 'Newsletter') {
      return {
        el: '#newsletter',
        behavior: 'smooth'
      }
    }
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

function getRouteMeta(to) {
  const t = i18n.global.t
  const defaultDescription = t('routeMeta.defaultDescription')

  if (to.meta?.routeKey === 'learn') {
    return {
      title: t('routeMeta.learn.title'),
      description: t('routeMeta.learn.description'),
      ogTitle: t('routeMeta.learn.ogTitle'),
      ogDescription: t('routeMeta.learn.ogDescription'),
      ogImage: to.meta.ogImage || '',
      robots: to.meta.robots || 'index,follow'
    }
  }

  if (to.meta?.routeKey === 'aiActImage') {
    return {
      title: t('routeMeta.aiActImage.title'),
      description: t('routeMeta.aiActImage.description'),
      ogTitle: t('routeMeta.aiActImage.ogTitle'),
      ogDescription: t('routeMeta.aiActImage.ogDescription'),
      ogImage: to.meta.ogImage || '',
      robots: to.meta.robots || 'index,follow'
    }
  }

  return {
    title: 'Personal Coding',
    description: defaultDescription,
    ogTitle: 'Personal Coding',
    ogDescription: defaultDescription,
    ogImage: to.meta?.ogImage || '',
    robots: to.meta?.robots || 'index,follow'
  }
}

function applyRouteMeta(to) {
  const meta = getRouteMeta(to)
  const { title, description, ogTitle, ogDescription, ogImage, robots } = meta

  document.title = title

  const setMeta = (attr, key, value) => {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`)
    if (!el) {
      el = document.createElement('meta')
      el.setAttribute(attr, key)
      document.head.appendChild(el)
    }
    el.setAttribute('content', value)
  }

  setMeta('name', 'description', description)
  setMeta('name', 'robots', robots)
  setMeta('property', 'og:title', ogTitle)
  setMeta('property', 'og:description', ogDescription)
  setMeta('property', 'og:type', 'website')
  setMeta('property', 'og:url', window.location.origin + to.fullPath)
  if (ogImage) setMeta('property', 'og:image', ogImage)
  setMeta('name', 'twitter:card', 'summary')
  setMeta('name', 'twitter:title', title)
  setMeta('name', 'twitter:description', description)
  if (ogImage) setMeta('name', 'twitter:image', ogImage)

  let linkCanonical = document.head.querySelector('link[rel="canonical"]')
  if (!linkCanonical) {
    linkCanonical = document.createElement('link')
    linkCanonical.setAttribute('rel', 'canonical')
    document.head.appendChild(linkCanonical)
  }
  linkCanonical.setAttribute('href', window.location.origin + to.fullPath)
}

router.afterEach((to) => applyRouteMeta(to))

watch(i18n.global.locale, () => {
  applyRouteMeta(router.currentRoute.value)
})

export default router
